import { Group, Progress, Text } from '@mantine/core';
import type { Strength } from '@/lib/entropy';
import { useStrings } from '@/i18n/useLang';

export function StrengthMeter({ strength }: { strength: Strength }) {
  const t = useStrings();
  const color = `var(${strength.colorToken})`;

  return (
    <div>
      <Group justify="space-between" mb={6}>
        <Text size="sm" c="dimmed">
          {t.pw.entropy}: {Math.round(strength.bits)} bit
        </Text>
        <Text size="sm" fw={600} style={{ color }}>
          {t.strength[strength.level]}
        </Text>
      </Group>
      <Progress
        value={strength.fraction * 100}
        color={color}
        radius="xl"
        size="md"
        aria-label={`${t.pw.entropy} ${Math.round(strength.bits)} bit`}
      />
    </div>
  );
}
